import { createStore, combineReducers} from "redux";
import sesion from "./reducers/sesion";

export default createStore(
    combineReducers({
        sesion
    })
);